export default __webpack_public_path__ + "static/media/logo-tauromarkets-white2.5ec75bfe.svg";